import { createVNode, mergeProps } from 'vue';

function markWrapper(icon, text, classes, style, on) {
  return createVNode("span", mergeProps({
    "contenteditable": "false",
    "class": classes ? `se-mark ${classes.join(' ')}` : 'se-mark',
    "style": style
  }, on), [icon, text]);
}

export { markWrapper };
//# sourceMappingURL=mark-wrapper.js.map
